module.exports = __webpack_public_path__ + "img/cactus-logo.f1593ce1.png";